var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"code-input-page"},[_c('textarea',{ref:"text",staticClass:"code",style:({ maxHeight: `${_vm.height}px` }),on:{"input":_vm.textChange,"blur":_vm.init}})])
}
var staticRenderFns = []

export { render, staticRenderFns }